// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".the-personal-icon.icon-info{fill:#8f90a6}", ""]);
// Exports
module.exports = exports;
